import Fuse from "fuse.js";

import {
    mapState,
    mapGetters,
    mapActions
} from 'vuex';

import {
    UNSUCCESS_SEARCH,
    NO_DIRECT_MATCHES,
    SEARCH_DATA_CHANGE,
    ERASE_SEARCH_STRING
} from '../../utils/constants/bus-events-constants'

import debounce from 'lodash/debounce';

export default {
    data() {
        return {
            value: '',
            oldValue: '',
            searchValue: '',
            searchDelay: 350,
            searchTimeout: null,
            isHandleClearEmit: false, // when we cleared the search with the clear button, this parameter become true by 1s
            expansionMergedData: false,
        }
    },
    computed: {
        ...mapState({
            mapLanguages: state => state.map.meta.languages
        }),
        ...mapGetters([
            't',
            'getBrandsAZ',
            'getTenantsAZ',
            'getMapConfigProp',
            'getChildCategories',
            'getServicesObjects',
            'getServiceCategories',
            'getTenantCategoriesRoot'
        ]),

        // ------------ Search params -------------

        isWideSearchResultShow() {
            return this.getMapConfigProp('features.search.wide', false)
        },
        strictSearchOptions(){
            return {
                keys: this.fuseSearchKeys,
                threshold: this.getMapConfigProp('features.search.strict.threshold', 0.2),
                location: this.getMapConfigProp('features.search.strict.location', 8),
            }
        },
        wideSearchOptions(){
            return {
                keys: this.fuseSearchKeys,
                threshold: this.getMapConfigProp('features.search.wide.threshold', 0.6),
                location: this.getMapConfigProp('features.search.wide.location', 1),
            }
        },
        numberLettersRequiredForStrictSearch () {
            return this.getMapConfigProp('features.search.numberLettersRequiredForStrictSearch', 3)
        },

        // ------------ End search params ---------

        mergedData() {
            const tenants = this.getTenantsAZ;
            const serviceCategories = this.getServiceCategories;
            const serviceObjects = this.getServicesObjects;
            const merged = [...serviceObjects, ...tenants, ...serviceCategories, ...( this.expansionMergedData ? [...this.brands, ...this.categories] : [] )];

            // TODO: move not related to search functionality to appropriate place
            const to = parseInt(this.$route.query.to, 10);
            const from = parseInt(this.$route.query.from, 10) || null;
            return this.mode === 'start' ? merged.filter(item => item.id !== to) : from ? merged.filter(item => item.id !== from) : merged;
        },

        fuseSearchKeys() {
            const languages = this.mapLanguages;
            const options = ["meta.name"];
            languages.forEach(item => {
                options.push(`meta.name_${item}`, `meta.alt_names_${item}`)
            });
            return options;
        },
        hasStrictResult: function () {
            return !!this.strictSearchResults.length;
        },
        strictSearchResults(){
            return (new Fuse(this.mergedData, this.strictSearchOptions)).search(this.searchValue);
        },
        wideSearchResults(){
            return (new Fuse(this.mergedData, this.wideSearchOptions)).search(this.searchValue);
        },
        getItems(){ // TODO: re-name to searchResults
            const showStrict = this.strictSearchResults.length;
            const showWide = this.isWideSearchResultShow;

            return showStrict && this.strictSearchResults ||
                showWide && this.wideSearchResults ||
                [];
        },
        /**
         * this.getMapConfigProp('features.search.unsuccessfulSearchRate', 0.6) -
         * this is the ratio of the number of deleted letters after which we consider that the search was unsuccessful
         * @return {boolean} true if search unsuccessful
         */
        isSearchStringErase() {
            return this.oldValue.length >= 2
                && (this.oldValue.length - this.value.length)/this.oldValue.length >= this.getMapConfigProp('features.search.unsuccessfulSearchRate', 0.6)
        },
        brands() {
            let brands = this.getBrandsAZ;
            brands = brands.map(brand => ({...brand, type: 'brand'}))
            return brands
        },
        categories() {
            let categories =  this.getChildCategories(this.t(this.getTenantCategoriesRoot, 'id'));
            categories = categories.map(category => ({...category, type: 'category'}))
            return categories
        },
    },
    methods:{
        ...mapActions([
            'sendSearchEvent'
        ]),
        handleClear() {
            if (this.$route.name.includes('web') && this.oldValue.length > 2) {
                //this.$bus.$emit(UNSUCCESS_SEARCH)
                this.isHandleClearEmit = true
                setTimeout(() => {this.isHandleClearEmit = false})
            }
        }
    },
    watch: {
        getItems(results){
            if(results){
                this.placeholders = false; // hide placeholders
                // this.sendSearchEvent({value1: this.searchValue}); //send statistics
            }
        },
        value() {
            clearTimeout(this.searchTimeout)
            this.placeholders = this.value && true
            this.searchTimeout = setTimeout(() => this.searchValue = this.value, this.searchDelay )
            if(this.value >= this.oldValue) this.oldValue = this.value
            this.$nextTick(() => {
                this.$bus.$emit(SEARCH_DATA_CHANGE, {
                    searchValue: this.value,
                    oldValue: this.oldValue,
                    searchResultsCount: this.getItems.length
                })
            })
        },
        isSearchStringErase(value) {
            if(value) {
                if(this.isHandleClearEmit) {
                    this.$bus.$emit(UNSUCCESS_SEARCH)
                } else {
                    this.$bus.$emit(ERASE_SEARCH_STRING, {
                        value1: this.oldValue,
                        value2: "not_found",
                        value3: "erase",
                        target_id: this.getItems.length
                    } )
                }
                this.oldValue = this.value
            }
        },
        hasStrictResult: debounce(function(newValue) {
            !newValue && this.$bus.$emit(NO_DIRECT_MATCHES);
        },2000)
    },
    mounted() {
        this.$bus.$emit(SEARCH_DATA_CHANGE, {})
    },
    beforeDestroy(){
        clearTimeout(this.searchTimeout)
    }
}
